const pidController = (function () {
	const data = {
		mazda: {
			default: {
				requestQuote: {
					desktop: 101100110,
					tablet: 101100113,
					mobile: 101100114
				},
				reserveYours: {
					desktop: 101100154,
					tablet: 101100155,
					mobile: 101100156
				},
				serviceAppt: {
					desktop: 601000,
					tablet: 101200101,
					mobile: 101200102
				},
				testDrive: {
					desktop: 101100111,
					tablet: 101100115,
					mobile: 101100116
				},
				tradeInValue: {
					desktop: 101102006,
					tablet: 101102007,
					mobile: 101102008
				},
			}
		},
		cpo: {
			details: {
				contact: {
					desktop: 101100136,
					tablet: 101100130,
					mobile: 101100133
				}
			},
			listing: {
				contact: {
					desktop: 101100135,
					tablet: 101100135,
					mobile: 101100132
				}
			},
			saved: {
				contact: {
					desktop: 101100137,
					tablet: 101100137,
					mobile: 101100137
				}
			}
		},
		buildPrice: {
			isIframe: {
				contactDealer: {
					desktop: 101100112,
					tablet: 101100127,
					mobile: 101100128
				},
				requestQuote: {
					desktop: 101100107,
					tablet: 101100123,
					mobile: 101100124
				},
				testDrive: {
					desktop: 101100108,
					tablet: 101100125,
					mobile: 101100126
				}
			},
			notIframe: {
				contactDealer: {
					desktop: 101100109,
					tablet: 101100121,
					mobile: 101100122
				},
				requestQuote: {
					desktop: 101100101,
					tablet: 101100117,
					mobile: 101100118
				},
				testDrive: {
					desktop: 101100102,
					tablet: 101100119,
					mobile: 101100120
				}
			}
		}
	};
	return {
		getPid: function (formType) {
			let pidValue, windowSize, cpoVal, iframeVal;
			const path = window.location.pathname;

			//set window size
			if (window.outerWidth > 1025) {
				windowSize = 'desktop';
			} else if (window.outerWidth > 767) {
				windowSize = 'tablet';
			} else {
				windowSize = 'mobile';
			}

			const url = window.location.hostname;
			const subdomain = url.split('.')[0];

			//check which values to use
			if (subdomain == 'cpo') {
				if (path.search('vehicle-listings') == 1) {
					cpoVal = 'listing';
				} else if (path.search('vehicle-details') == 1) {
					cpoVal = 'details';
				} else {
					cpoVal = 'saved';
				}

				try {
					pidValue = data[subdomain][cpoVal][formType][windowSize];
				}
				catch (err) {
					pidValue = undefined;
				}
			}
			else if (path.search('build-price') >= 1 || path.search('construction-prix') >= 1) {
				//detect iframe
				window.frameElement
					? iframeVal = 'isIframe'
					: iframeVal = 'notIframe';

				try {
					pidValue = data['buildPrice'][iframeVal][formType][windowSize];
				}
				catch (err) {
					pidValue = undefined;
				}
			}
			else {
				try {
					pidValue = data['mazda']['default'][formType][windowSize];
				}
				catch (err) {
					pidValue = undefined;
				}
			}

			if (pidValue == undefined) {
				pidValue = 0;
				console.log('Warning: pid not found in getPid in pidController.js');
			}

			return pidValue;
		},
	};
})();

export default pidController;